import { Col } from 'components/Col';
import { CustomTextArea } from 'components/CustomTextArea';
import { HelpButton } from 'components/HelpButton';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import InfosCamposModal from 'pages/FluxoProjetos/Components/infosCamposModal/infosCamposModal';
import { ChangeEvent, useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from 'store/modules/ModalActions';
import languageValues from 'utils/LanguageUtils';
import { getUniqueKey } from 'utils/NumberUtils';

const language = languageValues.inputs.descricaoTerritorioInvestigado;
export default function TerritorioInvestigado() {
  const { state, dispatch, validator } = useContext(ProjetosContext);

  const d = useDispatch();

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'descricaoTerritorioInvestigado',
        etapa: EtapaProjeto.expedicao,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  const label = useMemo(() => {
    return (
      <Col noPadding flex gap='8px' centralized>
        {language.label(state.projeto.flgInfantil)}
        {state.projeto.flgInfantil && (
          <HelpButton
            text={language.tooltip}
            onClick={() => {
              const modalKey = getUniqueKey();
              d(
                openModal(InfosCamposModal, {
                  modalKey,
                  title: language.modal.title,
                  text: language.modal.text,
                })
              );
            }}
          />
        )}
      </Col>
    );
  }, [d, state.projeto.flgInfantil]);

  return (
    <Row>
      <Col>
        <CustomTextArea
          label={label}
          placeholder={language.placeholder}
          name='descricaoTerritorioInvestigado'
          value={state.projeto.descricaoTerritorioInvestigado || ''}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: {
                descricaoTerritorioInvestigado: event.target.value,
              },
            });
          }}
          counter={true}
          maxSize={2000}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
